import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '../../app.constants';
import { BaseMiscApiService } from 'src/app/_common/api/base-misc-api.service';
import { ServiceHistoricalApi } from './models/historical';
import { PrtgConstants } from '../prtg-constants';
import { DatesService, MediaTypes } from 'src/app/_common/services';
import { RangeKey } from 'src/app/_common/enum';
import { ServicesFilter } from '../models';

@Injectable({
    providedIn: 'root'
})
export class ServiceMiscApiService extends BaseMiscApiService {
    constructor(
        private datesService: DatesService,
        http: HttpClient) {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlPrtg;
        this.segmentApi = '/prtg/services';
    }

    getServices(page: number = 1, limit: number = 100): Observable<any> {
        if (AppConstants.IsDataLocal('prtg')) {
            return this.http.get<any>('assets/data/prtg/services.json');
        }

        return this.get<any>(`/services?page=${page}&limit=${limit}`);
    }

    getServiceHistory(serviceId: string, page: number = 1, limit: number = 100): Observable<ServiceHistoricalApi> {
        const last24 = this.datesService.preRangeDates(RangeKey.LAST24HOURS);
        const rawRange = this.datesService.RawUtcDateRange(last24.since, last24.until);

        if (AppConstants.IsDataLocal('prtg')) {
            return this.http.get<any>(`assets/data/prtg/SEB/${serviceId}.json`);
        }

        return this.get<any>(`/history?serviceId=${serviceId}&averageSecs=${PrtgConstants.AverageSecs}&${rawRange}&page=${page}&limit=${limit}`);
    }

    export(servicesFilter: ServicesFilter, format: MediaTypes): Observable<HttpEvent<Blob>> {
        return this.download('/export', format, { statuses: servicesFilter.statuses, types: servicesFilter.types });
    }
}
